export function loadAnalytics() {
  // Prevent loading GA multiple times
  if (window.dataLayer) return;

  // Load gtag script
  const script1 = document.createElement("script");
  script1.async = true;
  script1.src = "https://www.googletagmanager.com/gtag/js?id=G-G6WN8NR9BM";
  document.head.appendChild(script1);

  // Init gtag
  window.dataLayer = window.dataLayer || [];
  function gtag(){ window.dataLayer.push(arguments); }
  (window).gtag = gtag;

  gtag("js", new Date());
  gtag("config", "G-G6WN8NR9BM");
}